import type {
  SubmissionsExportMetaKey,
  SubmissionsExportParams,
} from "../../types/submission";

const EXPORT_META_KEYS = new Set<SubmissionsExportMetaKey>([
  "id",
  "created_at",
  "updated_at",
]);

export function isSubmissionsExportMetaKey(
  value: string,
): value is SubmissionsExportMetaKey {
  return EXPORT_META_KEYS.has(value as SubmissionsExportMetaKey);
}

function sameIdList(left: number[], right: number[]): boolean {
  return (
    left.length === right.length &&
    left.every((id, index) => id === right[index])
  );
}

/** `fields` и `order` для drag-and-drop: порядок в списке = порядок столбцов. */
export function resolveExportFieldParams(
  catalogIds: number[],
  orderedIds: number[],
  selectedIds: Set<number>,
): Pick<SubmissionsExportParams, "fieldIds" | "order"> {
  const selectedInOrder = orderedIds.filter((id) => selectedIds.has(id));
  const allSelected =
    catalogIds.length > 0 &&
    selectedInOrder.length === catalogIds.length &&
    catalogIds.every((id) => selectedIds.has(id));

  return {
    fieldIds:
      allSelected || selectedInOrder.length === 0 ? undefined : selectedInOrder,
    order: sameIdList(orderedIds, catalogIds) ? undefined : orderedIds,
  };
}

export function defaultDownloadFilename(contentType: string): string {
  if (contentType.includes("wordprocessingml")) return "submissions.docx";
  if (contentType.includes("spreadsheetml")) return "submissions.xlsx";
  return "submissions.csv";
}

export function buildSubmissionsExportQuery(
  params: SubmissionsExportParams,
): string {
  const query = new URLSearchParams();

  if (params.format) {
    query.set("format", params.format);
  }
  if (params.from) {
    query.set("from", params.from);
  }
  if (params.to) {
    query.set("to", params.to);
  }
  if (params.metaKeys?.length) {
    for (const metaKey of params.metaKeys) {
      query.append("meta[]", metaKey);
    }
  }
  if (params.fieldIds?.length) {
    query.set("fields", params.fieldIds.join(","));
  }
  if (params.order?.length) {
    query.set("order", params.order.join(","));
  }

  const serialized = query.toString();
  return serialized ? `?${serialized}` : "";
}
